import { Currency } from '@flixbus/honeycomb-react';
import { DiscountType } from '../../../types/Voucher';
import { InfoDisplayProps } from '../InfoDisplay';

const DiscountTypeFields = (data: DiscountType): InfoDisplayProps['fields'] => {
  const fields: InfoDisplayProps['fields'] = [];

  const getPercentage = (amount: number) => {
    return `${(amount * 100).toString()}%`;
  };

  if ('quantity' in data) {
    fields.push({
      label: 'Quantity',
      value: data.quantity.toString(),
    });
  }

  if ('credit' in data) {
    fields.push({
      label: 'Credit amount',
      value: <Currency value={data.credit.amount} code={data.credit.currency} />,
    });
    fields.push({
      label: 'Currency',
      value: `${data.credit.currency}`,
    });
  }

  if ('discount' in data) {
    fields.push({
      label: 'Discount amount',
      value: <Currency value={data.discount.amount} code={data.discount.currency} />,
    });
    fields.push({
      label: 'Currency',
      value: `${data.discount.currency}`,
    });
  }

  if ('percentage' in data) {
    fields.push({
      label: 'Percentage',
      value: getPercentage(data.percentage),
    });
  }

  // Fallback if no fields are added
  if (fields.length === 0) {
    fields.push({
      label: 'Unknown type',
      value: 'N/A',
    });
  }

  return fields;
};

export default DiscountTypeFields;
